import { BILLING_LEASING_COLLECTIONS_POLICY_ROLE_VALUES } from './facilities-leasing-policy.js';
export const FACILITIES_TENANT_MEMBERSHIP_STATUSES = [
    'ACTIVE',
    'SUSPENDED',
    'PENDING_APPROVAL',
    'REMOVED',
    'REJECTED',
    'BANNED',
];
const FACILITIES_TENANT_MEMBERSHIP_STATUS_SET = new Set(FACILITIES_TENANT_MEMBERSHIP_STATUSES);
export function isFacilitiesTenantMembershipStatus(value) {
    return FACILITIES_TENANT_MEMBERSHIP_STATUS_SET.has(value);
}
export const FACILITIES_MANAGED_MEMBERSHIP_TRANSITIONS = {
    ACTIVE: ['SUSPENDED', 'REMOVED'],
    SUSPENDED: ['ACTIVE', 'REMOVED'],
    REMOVED: ['ACTIVE'],
    PENDING_APPROVAL: [],
    REJECTED: [],
    BANNED: [],
};
export function isFacilitiesManagedMembershipTransitionAllowed(current, target) {
    return FACILITIES_MANAGED_MEMBERSHIP_TRANSITIONS[current].includes(target);
}
export function canAssignFacilitiesTenantRole(status) {
    return status === 'ACTIVE' || status === 'PENDING_APPROVAL';
}
export const FACILITIES_INTERNAL_ADMIN_ROLE_NAME = 'facilities.admin';
export const FACILITIES_INTERNAL_ADMIN_AUTHORITY_ROLE_NAMES = [
    'SYSTEM_ADMIN',
    'platform.superadmin',
    'platform.admin',
    FACILITIES_INTERNAL_ADMIN_ROLE_NAME,
];
/**
 * Tenant roles whose assignment changes a protected authority boundary.
 * Facilities leasing administrators can manage ordinary tenant roles, but
 * only internal Facilities administrators can grant or revoke these roles.
 */
export const FACILITIES_PROTECTED_TENANT_ROLE_NAMES = [
    FACILITIES_INTERNAL_ADMIN_ROLE_NAME,
    ...BILLING_LEASING_COLLECTIONS_POLICY_ROLE_VALUES,
];
export const FACILITIES_USER_MANAGEMENT_GLOBAL_ACTOR_ROLE_NAMES = [
    ...FACILITIES_INTERNAL_ADMIN_AUTHORITY_ROLE_NAMES,
    'facilities.leasing.admin',
];
export const FACILITIES_USER_MANAGEMENT_TENANT_ACTOR_ROLE_NAMES = [
    FACILITIES_INTERNAL_ADMIN_ROLE_NAME,
    'facilities.leasing.admin',
];
const FACILITIES_INTERNAL_ADMIN_AUTHORITY_ROLE_NAME_SET = new Set(FACILITIES_INTERNAL_ADMIN_AUTHORITY_ROLE_NAMES);
export function hasFacilitiesInternalAdminAuthority(globalRoleNames = [], tenantRoleNames = []) {
    return (globalRoleNames.some((roleName) => FACILITIES_INTERNAL_ADMIN_AUTHORITY_ROLE_NAME_SET.has(roleName)) || tenantRoleNames.includes(FACILITIES_INTERNAL_ADMIN_ROLE_NAME));
}
export const FACILITIES_TENANT_ASSIGNABLE_ROLE_NAMES = [
    FACILITIES_INTERNAL_ADMIN_ROLE_NAME,
    'facilities.leasing.admin',
    'facilities.leasing.viewer',
    'facilities.leasing.workflow.operator',
    'facilities.leasing.applicant-access.manager',
    'facilities.leasing.document-reviewer',
    'facilities.leasing.design-reviewer',
    'facilities.leasing.catalog-manager',
    'facilities.leasing.commercial-approver',
    'facilities.leasing.finance-deposit.operator',
    'facilities.leasing.contract-permit.operator',
    ...BILLING_LEASING_COLLECTIONS_POLICY_ROLE_VALUES,
    'facilities.coach',
];
const FACILITIES_TENANT_ASSIGNABLE_ROLE_NAME_SET = new Set(FACILITIES_TENANT_ASSIGNABLE_ROLE_NAMES);
export function isFacilitiesTenantAssignableRoleName(roleName) {
    return FACILITIES_TENANT_ASSIGNABLE_ROLE_NAME_SET.has(roleName);
}
const FACILITIES_PROTECTED_TENANT_ROLE_NAME_SET = new Set(FACILITIES_PROTECTED_TENANT_ROLE_NAMES);
export function isFacilitiesProtectedTenantRoleName(roleName) {
    return FACILITIES_PROTECTED_TENANT_ROLE_NAME_SET.has(roleName);
}
//# sourceMappingURL=facilities-tenant-user-authority.js.map